import { Link } from "react-router-dom";
import manufacturingResume from "../../assets/resumes/ManufacturingResume2025.pdf";
import Download from "../../assets/svgs/download.svg";
import "./styles.css";

function ManufacturingResume() {
  return (
    <div className="resumeContainer">
      <div className="projectLinks">
        <Link to={"/contact"} className="projectLink">
          Contact Me
        </Link>
        <a href={manufacturingResume} className="projectLink svgLink" download>
          <img src={Download} alt="Download" />
        </a>
        <Link to={"/resume"} className="projectLink">
          go back
        </Link>
      </div>

      <section>
        <h2>Summary</h2>
        <p>
          Results-driven Manufacturing Leader with over 6 years of experience in
          plastics manufacturing, specializing in process optimization,
          troubleshooting, and quality control. Proven ability to lead teams,
          maximize production efficiency, and implement process improvements
          that enhance Overall Equipment Effectiveness (OEE). Strong mechanical
          aptitude with expertise in machine operation, material handling, and
          lean manufacturing principles.
        </p>
      </section>
      <section>
        <h2>Experience</h2>
        <h3>
          CE Shepherd Co | Lead Thermoforming Operator | March 2024 - Present
        </h3>
        <ul>
          <li>
            Lead thermoforming operations in the production of cooling tower
            materials, ensuring high-quality output.
          </li>
          <li>
            Perform changeovers and process optimizations to improve efficiency
            and minimize downtime.
          </li>
          <li>
            Troubleshoot quality issues related to material thickness, forming
            defects, and machine inconsistencies.
          </li>
          <li>
            Work closely with maintenance and engineering teams to address
            machine performance issues and improve reliability.
          </li>
        </ul>
        <br />
        <h3>
          Pactiv Evergreen | Thermoforming Operator | December 2017 - June 2023
        </h3>
        <ul>
          <li>
            Achieved the highest production rates among all operators across
            multiple shifts, measured by OEE during my tenure.
          </li>
          <li>
            Led cross-functional teams to maximize production efficiency and
            maintain quality standards.
          </li>
          <li>
            Served as interim lead, coordinating teams to meet and exceed
            performance goals.
          </li>
          <li>
            Implemented process improvements that enhanced productivity and
            reduced scrap rates.
          </li>
        </ul>
      </section>
      <section>
        <h2>Skills</h2>
        <ul>
          <li>
            <strong>Machine Operation & Setup:</strong> Operate, adjust, and
            optimize thermoforming machines for various materials.
          </li>
          <li>
            <strong>Material Knowledge:</strong> Work with various plastics
            (ABS, PET, HIPS, PVC), monitor sheet quality, and adjust process
            parameters to minimize defects.
          </li>
          <li>
            <strong>Troubleshooting & Problem-Solving:</strong> Diagnose and
            resolve issues related to temperature inconsistencies, forming
            defects, and vacuum issues.
          </li>
          <li>
            <strong>Quality Control & Inspection:</strong> Conduct visual and
            dimensional inspections using calipers and micrometers, ensuring
            parts meet customer specifications.
          </li>
          <li>
            <strong>Mechanical & Electrical Aptitude:</strong> Assist in
            maintenance, replace worn components, and troubleshoot systems such
            as air and hydraulics.
          </li>
          <li>
            <strong>Efficiency & Productivity:</strong> Reduce downtime during
            mold changes, optimize cycle times, and implement lean manufacturing
            principles.
          </li>
          <li>
            <strong>Safety & Compliance:</strong> Adhere to OSHA safety
            standards, follow lockout/tagout (LOTO) procedures, and maintain a
            safe work environment.
          </li>
          <li>
            <strong>Teamwork & Communication:</strong> Collaborate with
            maintenance and quality teams, document machine performance, and
            train new operators.
          </li>
        </ul>
      </section>
      <section>
        <h2>Education</h2>
        <p>
          <strong>Navarro College</strong> | Corsicana, TX
        </p>
        <p>Associate of Applied Science (CIT) | August 2022</p>
        <p>Dean’s List 2021 & 2022</p>
      </section>
    </div>
  );
}

export default ManufacturingResume;
